<template>
  <nav v-if="breadcrumb && breadcrumb.length > 0" :aria-labelledby="id">
    <ul class="breadcrumb">
      <li class="breadcrumb-item" v-for="item in breadcrumb">
        <a :href="item.url">{{ item.text }}</a>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: {
    id: String,
    breadcrumb: Array,
  },
};
</script>
